import { productos } from "../data/db/Products";

const ProductCount = () => {
  const totalProducts = productos.length;

  return (
    <div
      className="relative my-6 group w-full md:w-auto"
    >
      <div className="relative flex flex-col items-center justify-center p-4 border border-primary/10 rounded-xl bg-white/5 backdrop-blur-sm hover:bg-white/10 transition-all duration-300 w-full md:max-w-xs md:ml-auto">
        {/* Número principal con efecto de gradiente */}
        <p
          
          className="text-4xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent"
        >
          {totalProducts}
        </p>

        {/* Texto descriptivo */}
        <p
          
          className="mt-2 text-sm font-medium text-dark/70 text-center"
        >
          Productos disponibles
        </p>

        {/* Efecto de brillo sutil al pasar el mouse */}
        <div className="absolute inset-0 rounded-xl pointer-events-none overflow-hidden">
          <div className="absolute -inset-2 opacity-0 group-hover:opacity-30 transition-opacity duration-300">
            <div className="w-full h-full bg-gradient-to-r from-primary/10 to-secondary/10 blur-sm" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCount;